import styled, { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledSocialProvidersRow = styled.div(({ theme }) => {
  return css`
    display: flex;
    flex-direction: row;
    gap: ${utils.rem(theme.Spacing.Size.Small)};

    & > * {
      flex: 1;
    }
  `;
});

export const StyledSocialProvider = styled.div<{
  theme: any;
  $isAppleIcon?: boolean;
}>(({ theme, $isAppleIcon }) => {
  return css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: ${utils.rem(theme.Spacing.Size.XSmall)};

    svg {
      padding-bottom: ${$isAppleIcon
        ? utils.rem(1)
        : '0'}; // @TODO remove after propper icon export
    }
  `;
});

export const StyledSocialProvidersList = styled.div(({ theme }) => {
  return css`
    display: flex;
    flex-direction: column;
    gap: ${utils.rem(theme.Spacing.Size.Small)};
  `;
});

export const StyledAnotherProviders = styled.div(({ theme }) => {
  return css`
    display: flex;
    flex-direction: column;
    gap: ${utils.rem(theme.Spacing.Size.Small)};
    margin-top: ${utils.rem(theme.Spacing.Size.Small)};
  `;
});

export const StyledSocialProvidersWrapper = styled.div(({ theme }) => {
  return css`
    display: flex;
    flex-direction: column;
    gap: ${utils.rem(theme.Spacing.Size.Small)};
  `;
});
